import { render, staticRenderFns } from "./CategoryCardMobile.vue?vue&type=template&id=6698b045&scoped=true"
import script from "./CategoryCardMobile.vue?vue&type=script&lang=js"
export * from "./CategoryCardMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698b045",
  null
  
)

export default component.exports